(function () {
  var steppers = document.querySelectorAll('[data-yl-qty-stepper]');

  steppers.forEach(function (stepper) {
    var input = stepper.querySelector('input[name="quantity"]');
    var buttons = stepper.querySelectorAll('[data-yl-qty-change]');

    if (!input || !buttons.length) return;

    function limits() {
      var min = Number(input.getAttribute('min') || 1);
      var maxAttr = input.getAttribute('max');
      var max = maxAttr ? Number(maxAttr) : Infinity;
      if (!Number.isFinite(min)) min = 1;
      if (!Number.isFinite(max)) max = Infinity;
      return { min: min, max: max };
    }

    // Typed values: whole numbers within min/max (an empty field, 0 or "2.5" would otherwise
    // reach the form and be rejected by the browser's min check or by /cart/add).
    function clampTyped() {
      var range = limits();
      var current = Math.floor(Number(input.value));
      if (!Number.isFinite(current)) current = range.min;
      var next = String(Math.min(range.max, Math.max(range.min, current)));
      if (input.value !== next) input.value = next;
    }

    input.addEventListener('change', clampTyped);
    input.addEventListener('blur', clampTyped);

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var delta = Number(button.getAttribute('data-yl-qty-change') || 0);
        var range = limits();
        var current = Number(input.value || range.min);

        if (!Number.isFinite(current)) current = range.min;

        input.value = String(Math.min(range.max, Math.max(range.min, current + delta)));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
})();
